// packages
import React from "react";
import * as Router from "react-router-dom";
// data
import * as XLSX from "xlsx";
// UI
import * as MUI from "@mui/material";
import * as MLab from "@mui/lab";
import * as MIcons from "@mui/icons-material";
// models
import { MyAppM } from "../models/MyAppM";
import * as MZ from "../models/MZ";
import * as mz from "../models/mz/mz";
// layouts
import MyPage from "../layouts/MyPage";
// components
import MyTable from "../components/MyTable";
import MyFormDialog from "../components/MyFormDialog";
import MyDataTable from "../components/MyDataTable";
import MyFilePicker from "../components/MyFilePicker";

const MyBudgetsForecasts = () => {
  const RouterNavigate = Router.useNavigate();
  // const RouterLocation = Router.useLocation();
  const RouterParams = Router.useParams();
  // ui
  const [apiError, setApiError] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [dependants, setDependants] = React.useState(null);
  const [data, setData] = React.useState(null);
  const [addFormOpen, setAddFormOpen] = React.useState(false);
  const [importFormOpen, setImportFormOpen] = React.useState(false);

  // check if logged in
  React.useLayoutEffect(() => {
    if (MyAppM.checkUIDD() === false) RouterNavigate("/");
    (async () => {
      // data
      var r = await dependantsAPI();
      setLoading(false);
      if (r.success === false) {
        setApiError(r.message);
      } else {
        setApiError(null);
        setDependants(r.data["data"]);
      }
    })();
    getData();
  }, []);

  async function getData() {
    // data
    var r = await getAPI();
    setLoading(false);
    if (r.success === false) {
      setApiError(r.message);
    } else {
      setApiError(null);
      setData(r.data["data"]["budget-estimates"]);
    }
  }

  return (
    <MyPage>
      {MZ.If(
        !!apiError,
        <MUI.Alert severity="error" sx={{ m: 3 }}>
          {apiError}
        </MUI.Alert>
      )}
      <MyDataTable
        sx={{ p: 1 }}
        small={true}
        loading={loading}
        title={MZ.T("budgets-forecasts")}
        titleActions={[
          {
            icon: "",
            text: MZ.T("import"),
            props: { variant: "outlined" },
            onClick: () => setImportFormOpen(true),
          },
          {
            icon: "",
            text: MZ.T("add"),
            props: { variant: "outlined" },
            onClick: () => setAddFormOpen(true),
          },
        ]}
        columns={[
          ...(["corporate"].includes(RouterParams.portal)
            ? [
                {
                  key: "property_id",
                  head: MZ.T("property"),
                  value: (k, v) => v.property_name ?? "-",
                },
              ]
            : []),
          ...(["corporate", "property"].includes(RouterParams.portal)
            ? [
                {
                  key: "outlet_id",
                  head: MZ.T("outlet"),
                  value: (k, v) => v.outlet_name ?? "-",
                },
              ]
            : []),
          {
            key: "year",
            head: MZ.T("year"),
            value: (k, v) => v.year,
          },
          {
            key: "count",
            head: MZ.T("progress"),
            value: (k, v) =>
              `${v.count} / ${
                new MZ.DateTime(v.year, 1, 1).leapYear() ? "366" : "365"
              }`,
          },
        ]}
        data={data ?? []}
      />
      <MyAddForm
        open={addFormOpen}
        setOpen={setAddFormOpen}
        loading={loading}
        setLoading={setLoading}
        data={data}
        dependants={dependants}
        apiError={apiError}
        onSubmit={() => {
          getData();
        }}
      />
      <MyImportForm
        open={importFormOpen}
        setOpen={setImportFormOpen}
        loading={loading}
        setLoading={setLoading}
        data={data}
        dependants={dependants}
        apiError={apiError}
        onSubmit={() => {
          getData();
        }}
      />
    </MyPage>
  );
};

export default MyBudgetsForecasts;

//============< filterForm
const MyAddForm = (props) => {
  // form
  var formController = MZ.FormController();
  const [apiError, setApiError] = React.useState(null);
  //
  return (
    <MyFormDialog
      open={props.open}
      title={MZ.T("add")}
      onSubmit={async (form) => {
        if (apiError) setApiError(null);
        if (formController.valid()) {
          props.setLoading(true);
          var r = await addAPI(formController.toFormData());
          props.setLoading(false);
          if (r.success === false) {
            setApiError(r.message);
          } else {
            if (props.onSubmit) props.onSubmit();
            setApiError(null);
            props.setOpen(false);
          }
        }
      }}
      maxWidth="md"
      actions={[
        <MLab.LoadingButton
          key={MZ.GetKey()}
          startIcon={<MIcons.Close />}
          loading={false}
          loadingPosition="start"
          type="cancel"
          variant="contained"
          onClick={() => {
            props.setOpen(false);
          }}
        >
          {MZ.T("cancel")}
        </MLab.LoadingButton>,
        <MLab.LoadingButton
          key={MZ.GetKey()}
          startIcon={<MIcons.Send />}
          loading={props.loading}
          loadingPosition="start"
          type="submit"
          variant="contained"
        >
          {MZ.T("save")}
        </MLab.LoadingButton>,
      ]}
    >
      {MZ.If(
        !!apiError,
        <MUI.Alert severity="error" sx={{ m: 3, mt: 0 }}>
          {apiError}
        </MUI.Alert>
      )}
      <MUI.Grid
        container
        direction="row"
        spacing={1}
        justifyContent="flex-start"
        alignItems="stretch"
        sx={{ mb: 3 }}
      >
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="outlet_id"
            index={0}
            initValue={null}
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                className="w100"
                label={MZ.T("outlet")}
                name="outlet_id"
                select={true}
                type="text"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                children={
                  props.dependants
                    ? MZ.ForEach(props?.dependants?.outlets, (k, v) => (
                        <MUI.MenuItem key={`AFO-${k}`} value={v.id}>
                          {v.name}
                        </MUI.MenuItem>
                      ))
                    : null
                }
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="date"
            index={0}
            initValue={null}
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                className="w100"
                label={MZ.T("date")}
                name="date"
                type="date"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12}>
          <MUI.Divider sx={{ my: 1, backgroundColor: "primary.main" }} />
        </MUI.Grid>

        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="covers_budget"
            index={0}
            initValue={null}
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                className="w100"
                label={MZ.T("budget-covers")}
                name="covers_budget"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="total_budget"
            index={0}
            initValue={null}
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                className="w100"
                label={MZ.T("budget-total")}
                name="total_budget"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="food_budget"
            index={0}
            initValue={null}
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                className="w100"
                label={MZ.T("budget-food")}
                name="food_budget"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="beverage_budget"
            index={0}
            initValue={null}
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                className="w100"
                label={MZ.T("budget-beverage")}
                name="beverage_budget"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="other_budget"
            index={0}
            initValue={null}
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                className="w100"
                label={MZ.T("budget-other")}
                name="other_budget"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12}>
          <MUI.Divider sx={{ my: 1, backgroundColor: "primary.main" }} />
        </MUI.Grid>

        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="covers_forecast"
            index={0}
            initValue={null}
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                className="w100"
                label={MZ.T("forecast-covers")}
                name="covers_forecast"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="total_forecast"
            index={0}
            initValue={null}
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                className="w100"
                label={MZ.T("forecast-total")}
                name="total_forecast"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="food_forecast"
            index={0}
            initValue={null}
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                className="w100"
                label={MZ.T("forecast-food")}
                name="food_forecast"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="beverage_forecast"
            index={0}
            initValue={null}
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                className="w100"
                label={MZ.T("forecast-beverage")}
                name="beverage_forecast"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="other_forecast"
            index={0}
            initValue={null}
            formController={formController}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                className="w100"
                label={MZ.T("forecast-other")}
                name="other_forecast"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </MUI.Grid>
      </MUI.Grid>
    </MyFormDialog>
  );
};
//============< filterForm
const MyImportForm = (props) => {
  // form
  var formController = MZ.FormController();
  //
  const [apiError, setApiError] = React.useState(null);
  const [imported, importedSet] = React.useState(null);
  const [outlets, outletsSet] = React.useState([]);
  //
  return (
    <MyFormDialog
      open={props.open}
      title={MZ.T("import")}
      onSubmit={async (form) => {
        if (apiError) setApiError(null);
        if (formController.valid()) {
          let data = mz.linkObjectData(
            imported["data"],
            formController.toFormData(),
            {
              outlet_id: ["outlets_names[]", "outlets_ids[]"],
            },
            {
              date: (value) =>
                new mz.DateTime(
                  mz.round((value - 25569) * 86400 * 1000)
                ).formatDateTime(),
            }
          );
          let fd = mz.arrayOfObjectsToFormData(data);
          props.setLoading(true);
          var r = await addAPI(fd);
          props.setLoading(false);
          if (r.success === false) {
            setApiError(r.message);
          } else {
            if (props.onSubmit) props.onSubmit();
            setApiError(null);
            props.setOpen(false);
          }
        }
      }}
      maxWidth="md"
      actions={[
        <MLab.LoadingButton
          key={MZ.GetKey()}
          startIcon={<MIcons.Close />}
          loading={false}
          loadingPosition="start"
          type="cancel"
          variant="contained"
          onClick={() => {
            props.setOpen(false);
          }}
        >
          {MZ.T("cancel")}
        </MLab.LoadingButton>,
        <MLab.LoadingButton
          key={MZ.GetKey()}
          startIcon={<MIcons.Send />}
          loading={props.loading}
          loadingPosition="start"
          type="submit"
          variant="contained"
        >
          {MZ.T("import")}
        </MLab.LoadingButton>,
      ]}
    >
      {MZ.If(
        !!apiError,
        <MUI.Alert severity="error" sx={{ m: 3, mt: 0 }}>
          {apiError}
        </MUI.Alert>
      )}
      <MUI.Grid
        container
        direction="row"
        spacing={1}
        justifyContent="flex-start"
        alignItems="stretch"
        sx={{ mb: 3 }}
      >
        <MUI.Grid item xs={12}>
          <MyFilePicker
            accept=".xlsx,.xls,.csv,.tsv"
            onChange={async (evt, file) => {
              if (file) {
                var set = await mz.parseDataSheet(file, XLSX);
                importedSet(set);
                // for (let k of set.keys) {
                //   console.log(k, findInKeys(k));
                // }

                function findInKeys(value) {
                  const keys = {
                    outlet: ["outlet"],
                    date: ["date"],
                    covers_budget: ["covers budget"],
                    total_budget: ["total budget"],
                    food_budget: ["food budget"],
                    beverage_budget: ["beverage budget"],
                    other_budget: ["other budget", "misc budget"],
                    covers_forecast: ["covers forecast"],
                    total_forecast: ["total forecast"],
                    food_forecast: ["food forecast"],
                    beverage_forecast: ["beverage forecast"],
                    other_forecast: ["other forecast", "misc forecast"],
                  };
                  value = value?.toLowerCase().split(" ");
                  for (let k in keys) {
                    let searches = keys[k];
                    let points = 0;
                    for (let search of searches) {
                      console.log(search);
                    }
                  }
                  return null;
                }
              } else {
                importedSet(null);
                outletsSet([]);
              }
            }}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12}>
          <MUI.Divider sx={{ my: 1, backgroundColor: "primary.main" }} />
        </MUI.Grid>

        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="outlet_id"
            initValue={null}
            formController={formController}
            validator={MZ.ValidateText(true)}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                error={!!error}
                className="w100"
                label={MZ.T("outlet")}
                name="outlet_id"
                value={value}
                onChange={(evt) => {
                  setValue(evt.target.value);
                  if (evt.target.value) {
                    let arr = mz.cleanArray(
                      mz.unique(mz.arrayKey(imported.data, evt.target.value))
                    );
                    if (arr && arr.length < 100) outletsSet(arr);
                  } else outletsSet([]);
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                select={true}
                children={
                  imported
                    ? MZ.ForEach(imported.keys, (k, v) => (
                        <MUI.MenuItem key={`AFO-${k}`} value={v}>
                          {v}
                        </MUI.MenuItem>
                      ))
                    : []
                }
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="date"
            initValue={null}
            formController={formController}
            validator={MZ.ValidateText(true)}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                error={!!error}
                className="w100"
                label={MZ.T("date")}
                name="date"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                select={true}
                children={
                  imported
                    ? MZ.ForEach(imported.keys, (k, v) => (
                        <MUI.MenuItem key={`AFO-${k}`} value={v}>
                          {v}
                        </MUI.MenuItem>
                      ))
                    : []
                }
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12}>
          <MUI.Divider sx={{ my: 1, backgroundColor: "primary.main" }} />
        </MUI.Grid>

        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="covers_budget"
            initValue={null}
            formController={formController}
            validator={MZ.ValidateText(true)}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                error={!!error}
                className="w100"
                label={MZ.T("budget-covers")}
                name="covers_budget"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                select={true}
                children={
                  imported
                    ? MZ.ForEach(imported.keys, (k, v) => (
                        <MUI.MenuItem key={`AFO-${k}`} value={v}>
                          {v}
                        </MUI.MenuItem>
                      ))
                    : []
                }
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="total_budget"
            initValue={null}
            formController={formController}
            validator={MZ.ValidateText(true)}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                error={!!error}
                className="w100"
                label={MZ.T("budget-total")}
                name="total_budget"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                select={true}
                children={
                  imported
                    ? MZ.ForEach(imported.keys, (k, v) => (
                        <MUI.MenuItem key={`AFO-${k}`} value={v}>
                          {v}
                        </MUI.MenuItem>
                      ))
                    : []
                }
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="food_budget"
            initValue={null}
            formController={formController}
            validator={MZ.ValidateText(true)}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                error={!!error}
                className="w100"
                label={MZ.T("budget-food")}
                name="food_budget"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                select={true}
                children={
                  imported
                    ? MZ.ForEach(imported.keys, (k, v) => (
                        <MUI.MenuItem key={`AFO-${k}`} value={v}>
                          {v}
                        </MUI.MenuItem>
                      ))
                    : []
                }
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="beverage_budget"
            initValue={null}
            formController={formController}
            validator={MZ.ValidateText(true)}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                error={!!error}
                className="w100"
                label={MZ.T("budget-beverage")}
                name="beverage_budget"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                select={true}
                children={
                  imported
                    ? MZ.ForEach(imported.keys, (k, v) => (
                        <MUI.MenuItem key={`AFO-${k}`} value={v}>
                          {v}
                        </MUI.MenuItem>
                      ))
                    : []
                }
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="other_budget"
            initValue={""}
            formController={formController}
            validator={MZ.ValidateText(true)}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                error={!!error}
                className="w100"
                label={MZ.T("budget-other")}
                name="other_budget"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                select={true}
                children={
                  imported
                    ? MZ.ForEach(imported.keys, (k, v) => (
                        <MUI.MenuItem key={`AFO-${k}`} value={v}>
                          {v}
                        </MUI.MenuItem>
                      ))
                    : []
                }
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12}>
          <MUI.Divider sx={{ my: 1, backgroundColor: "primary.main" }} />
        </MUI.Grid>

        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="covers_forecast"
            initValue={null}
            formController={formController}
            validator={MZ.ValidateText(true)}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                error={!!error}
                className="w100"
                label={MZ.T("forecast-covers")}
                name="covers_forecast"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                select={true}
                children={
                  imported
                    ? MZ.ForEach(imported.keys, (k, v) => (
                        <MUI.MenuItem key={`AFO-${k}`} value={v}>
                          {v}
                        </MUI.MenuItem>
                      ))
                    : []
                }
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="total_forecast"
            initValue={null}
            formController={formController}
            validator={MZ.ValidateText(true)}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                error={!!error}
                className="w100"
                label={MZ.T("forecast-total")}
                name="total_forecast"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                select={true}
                children={
                  imported
                    ? MZ.ForEach(imported.keys, (k, v) => (
                        <MUI.MenuItem key={`AFO-${k}`} value={v}>
                          {v}
                        </MUI.MenuItem>
                      ))
                    : []
                }
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="food_forecast"
            initValue={null}
            formController={formController}
            validator={MZ.ValidateText(true)}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                error={!!error}
                className="w100"
                label={MZ.T("forecast-food")}
                name="food_forecast"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                select={true}
                children={
                  imported
                    ? MZ.ForEach(imported.keys, (k, v) => (
                        <MUI.MenuItem key={`AFO-${k}`} value={v}>
                          {v}
                        </MUI.MenuItem>
                      ))
                    : []
                }
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="beverage_forecast"
            initValue={null}
            formController={formController}
            validator={MZ.ValidateText(true)}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                error={!!error}
                className="w100"
                label={MZ.T("forecast-beverage")}
                name="beverage_forecast"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                select={true}
                children={
                  imported
                    ? MZ.ForEach(imported.keys, (k, v) => (
                        <MUI.MenuItem key={`AFO-${k}`} value={v}>
                          {v}
                        </MUI.MenuItem>
                      ))
                    : []
                }
              />
            )}
          />
        </MUI.Grid>
        <MUI.Grid item xs={12} sm={6}>
          <MZ.InputControllerWidget
            name="other_forecast"
            initValue={""}
            formController={formController}
            validator={MZ.ValidateText(true)}
            inputField={(value, setValue, error) => (
              <MUI.TextField
                error={!!error}
                className="w100"
                label={MZ.T("forecast-other")}
                name="other_forecast"
                type="number"
                value={value}
                onChange={(evt) => setValue(evt.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                select={true}
                children={
                  imported
                    ? MZ.ForEach(imported.keys, (k, v) => (
                        <MUI.MenuItem key={`AFO-${k}`} value={v}>
                          {v}
                        </MUI.MenuItem>
                      ))
                    : []
                }
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12}>
          <MyTable
            small={true}
            heads={[
              {
                children: [
                  [
                    { child: MZ.T("data") },
                    { child: MZ.T("outlet") },
                    { child: "", sx: { width: 25 } },
                  ],
                ],
              },
            ]}
            bodies={[
              {
                children: mz.forEach(outlets, (k, v) => {
                  return [
                    {
                      child: (
                        <MZ.InputControllerWidget
                          name={`outlets_names`}
                          index={k}
                          initValue={v}
                          formController={formController}
                          inputField={(value, setValue, error) => (
                            <MUI.TextField
                              className="w100"
                              name={`outlets_names`}
                              value={value}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          )}
                        />
                      ),
                    },
                    {
                      child: (
                        <MZ.InputControllerWidget
                          name={`outlets_ids`}
                          index={k}
                          initValue={null}
                          formController={formController}
                          validator={MZ.ValidateText(true)}
                          inputField={(value, setValue, error) => (
                            <MUI.TextField
                              error={!!error}
                              className="w100"
                              name={`outlets_ids`}
                              value={value}
                              onChange={(evt) => setValue(evt.target.value)}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              select={true}
                              children={
                                props.dependants
                                  ? MZ.ForEach(
                                      props.dependants["outlets"],
                                      (k, v) => (
                                        <MUI.MenuItem
                                          key={`IOS-${k}`}
                                          value={v.id}
                                        >
                                          {v.name}
                                        </MUI.MenuItem>
                                      )
                                    )
                                  : []
                              }
                            />
                          )}
                        />
                      ),
                    },
                    {
                      child: (
                        <MUI.IconButton
                          sx={{ color: "#f00" }}
                          onClick={() => {
                            let arr = [...outlets];
                            arr.splice(k, 1);
                            outletsSet(mz.cleanArray(arr));
                          }}
                          children={<MIcons.Delete />}
                        />
                      ),
                    },
                  ];
                }),
              },
            ]}
          />
        </MUI.Grid>
      </MUI.Grid>
    </MyFormDialog>
  );
};

// get transactions
async function dependantsAPI() {
  try {
    //========================= validate data
    let fData = new FormData();
    fData.set("UID", MyAppM.UIDD.UID);
    //========================= request
    return await MyAppM.exabyteRequest("client/transactions/dependants", fData);
  } catch (err) {
    return MZ.Error(err);
  }
}

// get transactions
async function getAPI() {
  try {
    //========================= validate data
    let fData = new FormData();
    fData.set("UID", MyAppM.UIDD.UID);
    //========================= request
    return await MyAppM.exabyteRequest("client/budget-estimates/get", fData);
  } catch (err) {
    return MZ.Error(err);
  }
}

// get transactions
async function addAPI(fData = new FormData()) {
  try {
    //========================= validate data
    fData.set("UID", MyAppM.UIDD.UID);
    //========================= request
    return await MyAppM.exabyteRequest("client/budget-estimates/add", fData);
  } catch (err) {
    return MZ.Error(err);
  }
}
